import { defaultFontFamily, alternateBorderColor, defaultBackgroundColorHover } from "../../styles/theme.js";
import "../../Styling.js";
import { mergeStyleSets, mergeStyles, HighContrastSelector, getTheme } from "@fluentui/style-utilities";
const accordionClassNames = {
  defaultClassName: "ane-Accordion",
  toggleIconClassName: "ane-Accordion-toggleIcon",
  linkClassName: "ane-Accordion-link",
  headerClassName: "ane-Accordion-header",
  headerTextClassName: "ane-Accordion-headertext",
  contentClassName: "ane-Accordion-content",
  contentContainerClassName: "ane-Accordion-contentContainer"
};
const getClassNames = (props, theme, styles, showContent) => mergeStyleSets({
  accordion: mergeStyles(accordionClassNames.defaultClassName, styles == null ? void 0 : styles.accordion, {
    fontFamily: defaultFontFamily,
    width: "100%"
  }),
  icon: mergeStyles(accordionClassNames.toggleIconClassName, styles == null ? void 0 : styles.icon, {
    fontSize: "12px",
    transition: "transform 0.2s ease-out",
    transform: showContent ? "rotate(0deg)" : "rotate(-90deg)"
  }),
  link: mergeStyles(accordionClassNames.linkClassName, styles == null ? void 0 : styles.link, {
    borderBottom: "1px solid " + alternateBorderColor,
    margin: "0",
    flexGrow: 1,
    padding: "1px",
    "&:hover": {
      textDecoration: "none"
    },
    [HighContrastSelector]: {
      borderBottom: "1px solid WindowText"
    }
  }),
  header: mergeStyles(accordionClassNames.headerClassName, styles == null ? void 0 : styles.header, {
    width: "100%",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: defaultBackgroundColorHover
    },
    [HighContrastSelector]: {
      "&:hover": {
        backgroundColor: "none"
      }
    }
  }),
  headerText: mergeStyles(accordionClassNames.headerTextClassName, styles == null ? void 0 : styles.headerText, {
    fontSize: "16px",
    [HighContrastSelector]: {
      color: "LinkText"
    }
  }),
  alert: [{ color: getTheme().palette.red }],
  content: mergeStyles(accordionClassNames.contentClassName, styles == null ? void 0 : styles.content, {
    display: showContent ? "block" : "none"
  }),
  contentContainer: mergeStyles(
    {
      paddingLeft: "33px"
    },
    accordionClassNames.contentContainerClassName,
    styles == null ? void 0 : styles.contentContainer
  ),
  horizontalLine: mergeStyles(accordionClassNames.contentContainerClassName, styles == null ? void 0 : styles.horizontalLine, {
    borderBottom: "1px solid " + alternateBorderColor,
    marginTop: "-1px",
    [HighContrastSelector]: {
      borderBottom: "1px solid WindowText"
    }
  })
});
export {
  getClassNames
};
//# sourceMappingURL=Accordion.styles.js.map
